import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Container } from './styles';

import Login from '../../pages/Login';
import NotFound from '../../pages/NotFound';
import ProducerReset from '../../../pages/ProducerReset';
import ProducerResetConfirm from '../../../pages/ProducerResetConfirm';
import PromoterReset from '../../../pages/PromoterReset';
import PromoterResetConfirm from '../../../pages/PromoterResetConfirm';

const Auth = () => (
  <Container>
    <div className="panel">
      {localStorage.getItem('token_admin') && (<Redirect to="/admin/dashboard" />)}
      <Switch>
        <Route exact path="/admin" component={Login} />
        <Route exact path="/admin/promoter/reset_password" component={PromoterReset} />
        <Route
          exact
          path="/admin/promoter/reset_password/confirm"
          component={PromoterResetConfirm}
        />
        <Route exact path="/admin/producer/reset_password" component={ProducerReset} />
        <Route
          exact
          path="/admin/producer/reset_password/confirm"
          component={ProducerResetConfirm}
        />
        <Route component={NotFound} />
      </Switch>
    </div>
  </Container>
);

export default Auth;



// WEBPACK FOOTER //
// ./src/admin/components/Auth/index.js